// Acciones del flujo de Tarjeta de Crédito Virtual (TCV).
// El mismo servicio Listar alimenta los distintos banners; cada oferta se guarda
// por tipo (pre-aprobada / solicitud / …). El resultado del Confirmar de la
// pre-aprobada se guarda para mostrar la tarjeta generada en la pantalla final.

export const TCV_SET_OFERTA_PREAPROBADA = 'tcv-set-oferta-preaprobada';
export const TCV_SET_OFERTA_SOLICITUD = 'tcv-set-oferta-solicitud';
export const TCV_SET_OFERTA_AUMENTO = 'tcv-set-oferta-aumento';
export const TCV_SET_RESULTADO_CONFIRMACION = 'tcv-set-resultado-confirmacion';
export const TCV_CLEAR = 'tcv-clear';

export const setOfertaPreaprobada = (oferta) => ({
  type: TCV_SET_OFERTA_PREAPROBADA,
  payload: { oferta },
});

export const setOfertaSolicitud = (oferta) => ({
  type: TCV_SET_OFERTA_SOLICITUD,
  payload: { oferta },
});

export const setOfertaAumento = (oferta) => ({
  type: TCV_SET_OFERTA_AUMENTO,
  payload: { oferta },
});

export const setResultadoConfirmacion = (resultado) => ({
  type: TCV_SET_RESULTADO_CONFIRMACION,
  payload: { resultado },
});

export const clearTcv = () => ({
  type: TCV_CLEAR,
});
